if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;
            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure("add:paint-updated-sections", () => {
                      this.cart.renderContents(response);
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure("add:paint-updated-sections", () => {
                this.cart.renderContents(response);
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            this.querySelector('.loading__spinner').classList.add('hidden');

            CartPerformance.measureFromEvent("add:user-action", evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }
      
      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
          const parentElement = this.closest('.product__info-wrapper.grid__item');
          const priceElement = parentElement.querySelector('.price__container');
          // this.submitButtonText.innerHTML = `<div class="custom-dynamic-price">${priceElement.innerHTML}</div>  -  ${ window.variantStrings.addToCart } <div class="cart-svg">
          //       <svg width="19" height="20" viewBox="0 0 19 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          //       <g clip-path="url(#clip0_439_3922)">
          //       <path d="M6.11915 13.0075H6.12002C6.12075 13.0075 6.12147 13.0073 6.1222 13.0073H16.2143C16.4628 13.0073 16.6813 12.8425 16.7495 12.6036L18.9761 4.81064C19.0241 4.64264 18.9904 4.46202 18.8854 4.32257C18.7801 4.18312 18.6156 4.10107 18.4409 4.10107H4.8354L4.43749 2.3104C4.38081 2.05571 4.15497 1.87451 3.89404 1.87451H0.554199C0.246742 1.87451 -0.00244141 2.1237 -0.00244141 2.43115C-0.00244141 2.73861 0.246742 2.98779 0.554199 2.98779H3.44757C3.51802 3.30511 5.35174 11.557 5.45727 12.0317C4.8657 12.2889 4.45068 12.8787 4.45068 13.564C4.45068 14.4847 5.19983 15.2339 6.1206 15.2339H16.2143C16.5218 15.2339 16.771 14.9847 16.771 14.6772C16.771 14.3698 16.5218 14.1206 16.2143 14.1206H6.1206C5.81373 14.1206 5.56396 13.8708 5.56396 13.564C5.56396 13.2575 5.81286 13.0082 6.11915 13.0075ZM17.7029 5.21435L15.7944 11.894H6.56707L5.0827 5.21435H17.7029Z" fill="#1C1A1B"></path>
          //       <path d="M5.56396 16.9038C5.56396 17.8246 6.31311 18.5737 7.23389 18.5737C8.15466 18.5737 8.90381 17.8246 8.90381 16.9038C8.90381 15.983 8.15466 15.2339 7.23389 15.2339C6.31311 15.2339 5.56396 15.983 5.56396 16.9038ZM7.23389 16.3472C7.54076 16.3472 7.79053 16.5969 7.79053 16.9038C7.79053 17.2107 7.54076 17.4604 7.23389 17.4604C6.92701 17.4604 6.67725 17.2107 6.67725 16.9038C6.67725 16.5969 6.92701 16.3472 7.23389 16.3472Z" fill="#1C1A1B"></path>
          //       <path d="M13.4312 16.9038C13.4312 17.8246 14.1803 18.5737 15.1011 18.5737C16.0218 18.5737 16.771 17.8246 16.771 16.9038C16.771 15.983 16.0218 15.2339 15.1011 15.2339C14.1803 15.2339 13.4312 15.983 13.4312 16.9038ZM15.1011 16.3472C15.408 16.3472 15.6577 16.5969 15.6577 16.9038C15.6577 17.2107 15.408 17.4604 15.1011 17.4604C14.7942 17.4604 14.5444 17.2107 14.5444 16.9038C14.5444 16.5969 14.7942 16.3472 15.1011 16.3472Z" fill="#1C1A1B"></path>
          //       </g>
          //       <defs>
          //       <clipPath id="clip0_439_3922">
          //       <rect width="19" height="19" fill="white" transform="translate(-0.00244141 0.724121)"></rect>
          //       </clipPath>
          //       </defs>
          //       </svg>
          //     </div>` ;

          this.submitButtonText.innerHTML = `
            <div class="cart-svg">                
                <svg width="19" height="19" viewBox="0 0 19 19" fill="none" xmlns="http://www.w3.org/2000/svg">
                    <path d="M6.12159 12.2853H6.12246C6.12319 12.2853 6.12391 12.2851 6.12464 12.2851H16.2168C16.4652 12.2851 16.6837 12.1203 16.752 11.8814L18.9785 4.08848C19.0265 3.92047 18.9929 3.73985 18.8878 3.6004C18.7826 3.46095 18.618 3.3789 18.4433 3.3789H4.83784L4.43993 1.58823C4.38325 1.33354 4.15741 1.15234 3.89648 1.15234H0.55664C0.249184 1.15234 0 1.40153 0 1.70898C0 2.01644 0.249184 2.26562 0.55664 2.26562H3.45001C3.52046 2.58294 5.35418 10.8348 5.45971 11.3096C4.86814 11.5667 4.45312 12.1566 4.45312 12.8418C4.45312 13.7626 5.20227 14.5117 6.12304 14.5117H16.2168C16.5242 14.5117 16.7734 14.2625 16.7734 13.9551C16.7734 13.6476 16.5242 13.3984 16.2168 13.3984H6.12304C5.81617 13.3984 5.5664 13.1487 5.5664 12.8418C5.5664 12.5353 5.8153 12.286 6.12159 12.2853ZM17.7054 4.49219L15.7968 11.1719H6.56952L5.08514 4.49219H17.7054Z" fill="#FDFAF5"/>
                    <path d="M5.56641 16.1777C5.56641 17.0985 6.31555 17.8477 7.23633 17.8477C8.1571 17.8477 8.90625 17.0985 8.90625 16.1777C8.90625 15.257 8.1571 14.5078 7.23633 14.5078C6.31555 14.5078 5.56641 15.257 5.56641 16.1777ZM7.23633 15.6211C7.5432 15.6211 7.79297 15.8709 7.79297 16.1777C7.79297 16.4846 7.5432 16.7344 7.23633 16.7344C6.92945 16.7344 6.67969 16.4846 6.67969 16.1777C6.67969 15.8709 6.92945 15.6211 7.23633 15.6211Z" fill="#FDFAF5"/>
                  <path d="M13.4336 16.1777C13.4336 17.0985 14.1827 17.8477 15.1035 17.8477C16.0243 17.8477 16.7734 17.0985 16.7734 16.1777C16.7734 15.257 16.0243 14.5078 15.1035 14.5078C14.1827 14.5078 13.4336 15.257 13.4336 16.1777ZM15.1035 15.6211C15.4104 15.6211 15.6602 15.8709 15.6602 16.1777C15.6602 16.4846 15.4104 16.7344 15.1035 16.7344C14.7966 16.7344 14.5469 16.4846 14.5469 16.1777C14.5469 15.8709 14.7966 15.6211 15.1035 15.6211Z" fill="#FDFAF5"/>
                </svg>
            </div>
             Add to Cart - Start my journey
          ` ;



              // const mobilePrice = document.querySelector('.mobile-price');
              // const copyPrice = priceElement.innerHTML;
              //   if (mobilePrice) {
              //     mobilePrice.innerHTML = copyPrice;
              //   }

          
        }
      }


      
      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}
